import { fontSizes, colors } from '../../../../Components/consts'
import { styled } from '@mui/system'

type StyleProps = {
  teamColor: string
}

export const TeamStatHeader = styled('h1')<StyleProps>(({ teamColor, theme }) => ({
  color: teamColor,
    fontSize: '1.2rem',
    fontWeight: 700,
    marginRight: 15,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginRight: 5,
    },
}))

export const MatchupStyle = styled('div')(({ theme }) => ({
  display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: theme.spacing(1),
    background: `${colors.gray.gray80}60`,
    padding: theme.spacing(0, 2),
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      width: '90%'
    },
    '& .date': {
      textAlign: 'center',
      '& p': {
        margin: theme.spacing(1, 1, 0),
        fontWeight: 600,
        fontSize: fontSizes.semiLarge,
        color: colors.lightestGrey,
        [theme.breakpoints.down('sm')]: {
          fontSize: fontSizes.medium,
        },
      },
    }
}))

export const StatConStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '70%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  '& .statName': {
    color: colors.lightestGrey,
    fontSize: '1rem',
    fontWeight: 600,
    margin: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },
}))

export const PrevMatchupCon = styled('div')(({ theme }) => ({
  display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: theme.spacing(1, 2),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1, 0)
    },
}))

export const PrevMatchupHead = styled('h1')(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 700,
  fontSize: fontSizes.semiLarge,
  color: colors.white,
  margin: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
  },
}))

export const PrevMatchupTeamHeadCon = styled('div')(({ theme }) => ({
  display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: theme.spacing(1, 2),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0),
    },
    '& .left': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginRight: theme.spacing(1),
      '& .teamLogo': {
        height: 45,
        margin: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
          height: 20,
        },
      },
      '& .teamInfo': {
        height: 45,
        margin: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
          height: 20,
        },
      }
    },
    '& .right': {
      display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    },
}))

export const PrevMatchupTeamLogo = styled('img')(({ theme }) => ({
  height: 45,
  margin: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    height: 20,
  },
}))

type TeamInfoProps = {
  side: string
}

export const PrevMatchupTeamInfo = styled('div')<TeamInfoProps>(({ side, theme }) => ({
  display: 'block',
    textAlign: side === 'left' ? 'left' : 'right',
    margin: theme.spacing(0, 1),
    '& h2': {
      fontWeight: 600,
      fontSize: fontSizes.medium,
      color: colors.white,
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
      },
    },
    '& p': {
      fontWeight: 500,
      fontSize: fontSizes.medium,
      color: colors.lightestGrey,
      marginTop: 5,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
        marginTop: 0,
      },
    },
}))

